// Bison brand tokens, generated by scripts/sync-brand.mjs from
// Bison-Office/Bison-brand v1.0.0 (f86c7d7), tokens/tokens.json. Do not edit:
// change the brand repo, release a tag, and run `npm run sync:sources`.
// theme/tokens.ts and theme/theme.ts read the brand values from here.
export const brand = {
    "version": "v1.0.0",
    "commit": "f86c7d7",
    "meta": {
        "name": "Bison Commerce",
        "version": "0.1.0"
    },
    "color": {
        "navy": "#001f37",
        "navy-light": "#0a3050",
        "orange": "#f03a11",
        "orange-bright": "#ff4a1f",
        "body": "#4b5367",
        "emphasis": "#3b3947",
        "muted": "#6b7387",
        "white": "#ffffff",
        "bg": "#f7f7f7",
        "surface": "#f0f0f6",
        "line": "#dadde5",
        "line-soft": "#e8e8ef"
    },
    "onNavy": {
        "ink": 1,
        "body": 0.75,
        "detail": 0.7,
        "muted": 0.6,
        "idle": 0.5,
        "numeral": 0.2,
        "rule-strong": 0.15,
        "rule": 0.1
    },
    "state": {
        "selection": "rgba(240,58,17,.16)",
        "focus-ring": {
            "color": "#f03a11",
            "width": "2px",
            "offset": "2px",
            "radius": "2px"
        },
        "field-focus": {
            "border": "#001f37"
        }
    },
    "type": {
        "sans": {
            "family": "Inter",
            "stack": "\"Inter\", ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", sans-serif",
            "weights": [
                300,
                400,
                500,
                600,
                700,
                800
            ]
        },
        "heading": {
            "weight": 800,
            "tracking": "-0.02em",
            "line": "1.05",
            "color": "#001f37"
        },
        "scale": {
            "display": {
                "size": "60px",
                "line": "1.05",
                "weight": 800,
                "tracking": "-0.02em"
            },
            "page-title": {
                "size": "48px",
                "line": "1.05",
                "weight": 800,
                "tracking": "-0.02em"
            },
            "section-title": {
                "size": "36px",
                "line": "1.05",
                "weight": 800,
                "tracking": "-0.02em"
            },
            "column-title": {
                "size": "24px",
                "line": "1.25",
                "weight": 800
            },
            "list-title": {
                "size": "20px",
                "line": "1.375",
                "weight": 800
            },
            "card-title": {
                "size": "18px",
                "line": "1.05",
                "weight": 800
            },
            "menu-title": {
                "size": "18px",
                "line": "1.375",
                "weight": 600
            },
            "subsection": {
                "size": "16px",
                "weight": 600
            },
            "numbered-label": {
                "size": "14px",
                "weight": 600,
                "numeric": "tabular"
            },
            "pull-quote": {
                "size": "24px",
                "line": "1.45",
                "weight": 500
            },
            "lead": {
                "size": "18px",
                "line": "1.625",
                "weight": 400
            },
            "body": {
                "size": "16px",
                "line": "1.625",
                "weight": 400
            },
            "row-term": {
                "size": "15px",
                "line": "1.375",
                "weight": 600
            },
            "small": {
                "size": "14px",
                "line": "1.625",
                "weight": 400
            },
            "text-link": {
                "size": "14px",
                "weight": 600
            },
            "eyebrow": {
                "size": "11px",
                "weight": 600,
                "tracking": "0.12em",
                "transform": "uppercase"
            },
            "band-label": {
                "size": "12px",
                "weight": 600,
                "tracking": "0.05em",
                "transform": "uppercase"
            },
            "caption": {
                "size": "12px",
                "weight": 400
            }
        }
    },
    "layout": {
        "container": "1280px",
        "gutter": "24px",
        "section": {
            "y": "96px",
            "ySm": "80px"
        },
        "measure": "672px",
        "measureNarrow": "448px",
        "ruleClearance": "48px",
        "navHeight": "64px"
    },
    "radius": {
        "sm": "6px",
        "md": "8px",
        "lg": "10px",
        "max": "10px",
        "full": "9999px"
    },
    "shadow": {
        "sm": "0 1px 2px rgba(0,31,56,.05)",
        "md": "0 4px 6px rgba(0,31,56,.06), 0 2px 4px rgba(0,31,56,.04)",
        "lg": "0 12px 28px rgba(0,31,56,.1), 0 6px 10px rgba(0,31,56,.05)",
        "xl": "0 24px 48px rgba(0,31,56,.12), 0 10px 18px rgba(0,31,56,.06)"
    },
    "motion": {
        "duration": {
            "hover": "150ms",
            "fade-up": "700ms",
            "fade-in": "800ms"
        },
        "easing": {
            "hover": "ease",
            "enter": "ease-out"
        },
        "distance": {
            "fade-up": "16px",
            "button-lift": "-1px",
            "glyph-lift": "-4px"
        }
    },
    "illustration": {
        "stroke": "#001f37",
        "top": "#ffffff",
        "lite-left": "#f3f5f9",
        "lite-right": "#e7ebf2",
        "panel": "#dadde5",
        "accent": "#f03a11",
        "guide-line": "#c3c9d6",
        "strokeWidth": {
            "scene": 1.7,
            "glyph": 1.45,
            "interior": 0.82
        }
    }
} as const;
